import pdfMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { useStore } from 'vuex'
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter'
import figureFormatter from '@/services/utils/figureFormatter'
import { formatNameWithSerial } from '@/services/utils/global.js'

pdfMake.vfs = pdfFonts.pdfMake.vfs

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const AMOUNT_COLUMNS = [
    { key: 'invoice_amount', label: 'INVOICE AMOUNT' },
    { key: 'discount_amount', label: 'DISCOUNT AMOUNT' },
    { key: 'net_bill_amount', label: 'NET BILL' },
    { key: 'paid_amount', label: 'PAID AMOUNT' },
    { key: 'due_amount', label: 'DUE AMOUNT' }
]

const pdfPrinter = () => {
    const store = useStore()
    const { getHeader, getFooter } = pdfHeaderFooter()
    const { commaFormat } = figureFormatter()

    const userName = store.state.user.user.name

    const exportToPDF = (company, statementData, startDate = '', endDate = '', filterLines = []) => {
        const doc = {
            pageSize: 'A4',
            pageMargins: [30, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(statementData, startDate, endDate, filterLines),
            styles: {
                header: {
                    fontSize: 20
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 9,
                font: 'SulaimanLipi'
            },
            info: {
                title: 'Client Sales Statement Summary'
            }
        }

        pdfMake.createPdf(doc).open()
    }

    const getContent = (statementData, startDate, endDate, filterLines) => {
        return [
            {
                text: 'Client Sales Statement Summary',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                decoration: 'underline'
            },
            {
                stack: [
                    { text: `Date: ${startDate} - ${endDate}` },
                    ...filterLines.map(text => ({ text }))
                ]
            },
            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: ['auto', 'auto', 'auto'].concat(AMOUNT_COLUMNS.map(() => 'auto')),
                    body: getTableBody(statementData)
                },
                layout: {
                    fillColor: (rowIndex) => {
                        if (rowIndex === 0) return '#f3f2f7'
                        return null
                    },
                    hLineWidth: () => 0.5,
                    vLineWidth: () => 0.5
                }
            }
        ]
    }

    const getTableBody = (statementData) => {
        return [
            getTableHead(),
            ...getTableRows(statementData.data.data),
            getTotals(statementData.totals)
        ]
    }

    const getTableHead = () => {
        return [
            { text: 'SL NO' },
            { text: 'CLIENT NAME' },
            { text: 'MOBILE' },
            ...AMOUNT_COLUMNS.map(column => ({ text: column.label, alignment: 'right' }))
        ]
    }

    const getTableRows = (rows) => {
        return rows.map((item, index) => {
            return [
                { text: index + 1 },
                { text: formatNameWithSerial(item.client_name, item.serial_no) },
                { text: item.mobile_no || '' },
                ...AMOUNT_COLUMNS.map(column => ({ text: String(commaFormat(item[column.key])), alignment: 'right' }))
            ]
        })
    }

    const getTotals = (totals) => {
        return [
            { text: 'Total', colSpan: 3, alignment: 'right' },
            { text: '' },
            { text: '' },
            ...AMOUNT_COLUMNS.map(column => ({ text: String(commaFormat(totals[column.key])), alignment: 'right' }))
        ]
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter
